export default __webpack_public_path__ + "static/media/shopify-login.eb060384.png";